import React from 'react';

const MarginLeakage = ({ data }) => {
  if (!data) return null;

  const { heading, highlightHeading, subHeading, adBankRoute, inrExpressRoute, footnote } = data;

  return (
    <section className="bg-[#072F5F] py-sp-100 sm:py-sp-big">
      <div className="container px-3 sm:px-3">
        {heading && (
          <h2 className="text-3xl sm:text-lg font-medium text-white mb-3 text-center">
            {heading}{' '}
            {highlightHeading && (
              <span className="text-[#FECC2F]">{highlightHeading}</span>
            )}
          </h2>
        )}
        {subHeading && (
          <p className="text-[#FFFFFF] text-base2 sm:text-sm text-center">
            {subHeading}
          </p>
        )}
        <div className="flex sm:flex-col gap-8 items-start mt-5">
          {adBankRoute && (
            <div className="sm:w-full w-[64%] flex flex-col">
              {adBankRoute.title && (
                <h3 className="text-3xl sm:text-lg font-medium text-white mb-3">
                  {adBankRoute.title}
                </h3>
              )}
              {adBankRoute.topCard && (
                <div className="bg-[#FFFFFF1A] border border-[#6A829F4D] rounded-2xl p-4 flex flex-col gap-2 shadow-md">
                  <div className="flex flex-col gap-1">
                    <span className="text-xxs sm:text-xs font-medium uppercase text-[#D7D7DC]">
                      {adBankRoute.topCard.tag}
                    </span>
                    <span className="text-heading1 sm:text-xl font-bold text-white">
                      {adBankRoute.topCard.stat}
                    </span>
                  </div>

                  <p className="text-white text-sm">
                    {adBankRoute.topCard.description}
                  </p>
                  <div className="flex w-full h-6 rounded-lg overflow-hidden bg-[#08172C] border border-[#FFFFFF33]">
                    {adBankRoute.topCard.legend?.map((item, idx) => (
                      <div
                        key={idx}
                        className={`h-full ${idx === 0 ? 'rounded-l-sm' : ''} ${idx === adBankRoute.topCard.legend.length - 1 ? 'rounded-r-sm' : ''
                          }`}
                        style={{ backgroundColor: item.color, width: item.width }}
                      />
                    ))}
                  </div>
                  <div className="flex flex-wrap items-center gap-3 sm:gap-1 text-xs text-[#FFFFFF]">
                    {adBankRoute.topCard.legend?.map((item, idx) => (
                      <div key={idx} className="flex items-center gap-1">
                        <span
                          className="w-1 h-1 rounded-sm shrink-0"
                          style={{ backgroundColor: item.color }}
                        />
                        <span className="text-[#CBD5E1]">{item.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              <div className="flex flex-wrap justify-between gap-y-2 mt-2">
                {adBankRoute.cards?.map((card) => (
                  <div
                    key={card.id}
                    className="w-[calc(50%-8px)] sm:w-full flex"
                  >
                    <div className="w-full bg-[#FFFFFF1A] border border-[#1E3A60] rounded-2xl p-3 flex flex-col justify-between shadow-md">
                      <div>
                        <span className="text-[10px] sm:text-xxs font-medium uppercase tracking-wider text-bordercolor block mb-1">
                          {card.tag}
                        </span>
                        <div className="text-xl sm:text-lg font-medium text-white mb-1">
                          {card.value}
                        </div>
                         {card.hasTimeline && (
                          <div className="relative flex items-center justify-between my-2 w-full">
                            <div className="absolute left-1 right-1 h-[2px] bg-bordercolor top-1/2 -translate-y-1/2 z-0" />
                            <span className="w-1 h-1 rounded-full bg-bordercolor z-10 shrink-0" />
                            <span className="w-1 h-1 rounded-full bg-bordercolor z-10 shrink-0" />
                            <span className="w-1 h-1 rounded-full bg-bordercolor z-10 shrink-0" />
                            <span className="w-1 h-1 rounded-full bg-[#FECC2F] z-10 shrink-0" />
                          </div>
                        )}
                        {card.description && (
                          <p className="text-[#EFEFF4] text-xs sm:text-sm">
                            {card.description}
                          </p>
                        )}
                      </div>

                      {card.tags && (
                        <div className="flex flex-wrap gap-1.5 mt-1">
                          {card.tags.map((tagItem, idx) => (
                            <span
                              key={idx}
                              className="bg-[#1B3457] border border-[#D7D7DC33] text-[#EFEFF4] text-xs px-1 py-xsp rounded-full"
                            >
                              {tagItem}
                            </span>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Right Column: With INRExpress */}
          {inrExpressRoute && (
            <div className="sm:w-full w-[35%] flex flex-col gap-4">
              {inrExpressRoute.title && (
                <h3 className="text-3xl sm:text-lg font-medium text-[#FECC2F]">
                  {inrExpressRoute.title}
                </h3>
              )}
              <div className="w-full bg-white rounded-2xl overflow-hidden shadow-2xl flex flex-col">
                <div className="bg-[#FECC2F] p-4 flex flex-col gap-1">
                  <span className="text-xs font-medium uppercase text-baseBlack">
                    {inrExpressRoute.badge}
                  </span>
                  <h4 className="text-lg sm:text-base font-bold text-[#000000]">
                    {inrExpressRoute.heading}
                  </h4>
                </div>
                <div className="p-4 flex flex-col gap-4 bg-white">
                  {inrExpressRoute.features?.map((feature) => (
                    <div key={feature.id} className="flex gap-1 items-start">
                      <div className="w-3 h-3 rounded-full bg-[#4A9447] flex items-center justify-center shrink-0 mt-0.5">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.5 10L8.5 14L15.5 6"
                            stroke="#FFFFFF"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="flex flex-col gap-0.5">
                        <h5 className="font-medium text-base text-[#072F5F]">
                          {feature.title}
                        </h5>
                        <p className="text-[#6F6F6F] text-xs">
                          {feature.description}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default MarginLeakage;
